// react
import React from "react";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import { useMediaQuery, useTheme } from "@mui/material";

// recharts
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

// ui-components
import CustomTooltip from "./CustomTooltip";

// A ---------------------------------------------------------------------- M

const MpsChart = ({ chartData }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  if (!chartData || chartData.length === 0) {
    return <div style={{ padding: 40, textAlign: "center", opacity: 0.6 }}>{t("no_data_available")}</div>;
  }

  const sensorKeys = Object.keys(chartData[0]).filter((k) => k !== "time");

  const stableColor = (key, theme) => {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 270;
    const saturation = 65;
    const lightness = theme.palette.mode === "dark" ? 60 : 40;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  return (
    <ResponsiveContainer width="100%" height={isMobile ? 300 : 500}>
      <LineChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 10 }}>
        <CartesianGrid stroke={theme.palette.divider} strokeDasharray="4 4" />

        <XAxis
          dataKey="time"
          type="number"
          domain={["auto", "auto"]}
          scale="time"
          interval={isMobile ? 20 : 4}
          tick={{ fill: theme.palette.text.secondary }}
          tickFormatter={(ts) =>
            new Date(ts).toLocaleString([], {
              hour: "2-digit",
              minute: "2-digit",
              day: "2-digit",
              month: "2-digit",
            })
          }
        />

        <YAxis domain={["dataMin - 1", "dataMax + 1"]} tick={{ fill: theme.palette.text.secondary }} />

        <Tooltip content={<CustomTooltip />} />

        <Legend />

        {sensorKeys.map((key) => (
          <Line key={key} dataKey={key} stroke={stableColor(key, theme)} strokeWidth={2} type="monotoneX" dot={false} activeDot={{ r: 4 }} isAnimationActive={false} />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default MpsChart;
